import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as apicall from "../../components/Apicall";
import { LuClipboardCheck, LuClock } from "react-icons/lu";
import { HiOutlineUsers } from "react-icons/hi2";
import Skeleton from "../../components/Loader/Skeleton";
import { Form, Table } from "react-bootstrap";
import { MdArrowBack } from "react-icons/md";
import { FaRegCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { MultiSelect } from "primereact/multiselect";
import ExcelIcon from "../../assets/images/vscode-icons_file-type-excel.svg";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import * as constants from "../../constants/Constants";
import RotateDevicePopup from "../../components/RotateDevicePopup/RotateDevicePopup";

function DashboardDetailed() {
  let { date } = useParams();
  const contentRef = useRef();

  // let d1 = date?.toLocaleDateString("en-GB")?.split(/[\/\-\.]/);
  // console.log("d1---", d1);
  // let d2 = `${d1[2]}-${d1[1]}-${d1[0]}`;
  // console.log("d2--", d2);

  // const today = new Date();
  const [dateRange, setDateRange] = useState([date, date]);
  const [startDate, endDate] = dateRange;

  const [loading, setLoading] = useState(false);
  const lastRequestId = useRef(0);
  const [orderCounts, setOrderCounts] = useState({
    total: 0,
    completed: 0,
    progress: 0,
    cancelled: 0,
  });
  const [fullData, setFullData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [allPartner, setAllPartner] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState([]);

  const [allProvider, setAllProvider] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState([]);

  const [allStatus, setAllStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const [allPayment, setAllPayment] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState([]);
  const [vendorData, setVendorData] = useState();
  const [downloadInv, setDownloadInv] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currency, setCurrency] = useState("AED");

  useEffect(() => {
    let u1 = localStorage.getItem("userDetails") || [];
    let userDetails = JSON.parse(u1);
    setCurrency(userDetails?.currency);
  }, []);

  useEffect(() => {
    getAllDropdown();
  }, []);

  useEffect(() => {
    getBookingByDate();
  }, [
    dateRange,
    selectedPartner,
    selectedProvider,
    selectedStatus,
    selectedPayment,
  ]);

  let headers = [
    "S.NO",
    "Invoice",
    "Booking ID",
    "Origin ID",
    "Profile",
    "Customer Name",
    "Phone Number",
    "Crew",
    "Service category",
    "Sub category",
    "Type",
    "Service Date",
    "Service Time",
    "Discount",
    "Tax",
    "Total",
    "Booking Status",
    "Payment Status",
  ];

  let exportheaders = [
    "S.NO",
    "Booking ID",
    "Origin ID",
    "Profile",
    "Customer Name",
    "Phone Number",
    "Crew",
    "Service category",
    "Sub category",
    "Type",
    "Service Date",
    "Service Time",
    "Discount",
    "Tax",
    "Total",
    "Booking Status",
    "Payment Status",
  ];

  let invoiceheaders = [
    "Booking ID",
    "Product/Services",
    "Discount",
    "Tax",
    "Total",
  ];

  let mappingColumns = {
    "S.NO": {
      name: "s_no",
      width: "4rem",
    },
    Invoice: {
      name: "invoice_id",
      width: "4rem",
    },
    "Booking ID": {
      name: "display_booking_id",
      width: "7rem",
    },
    "Origin ID": {
      name: "org_id",
      width: "7rem",
    },
    Profile: {
      name: "partner_name",
      width: "10rem",
    },
    "Customer Name": {
      name: "user_name",
      width: "10rem",
    },
    "Phone Number": {
      name: "phone_number",
      width: "10rem",
    },
    Crew: {
      name: "provider_names",
      width: "10rem",
    },
    "Service category": {
      name: "service_name",
      width: "10rem",
    },
    "Sub category": {
      name: "service_type_name",
      width: "10rem",
    },
    Type: {
      name: "service_offering_name",
      width: "10rem",
    },
    "Service Date": {
      name: "service_date",
      width: "10rem",
    },
    "Service Time": {
      name: "service_time",
      width: "10rem",
    },
    Discount: {
      name: "discount",
      width: "10rem",
    },
    Tax: {
      name: "tax",
      width: "10rem",
    },
    Total: {
      name: "total",
      width: "10rem",
    },
    "Booking Status": {
      name: "booking_status",
      width: "10rem",
    },
    "Payment Status": {
      name: "payment_status",
      width: "10rem",
    },
  };

  const formatDate = (d1) => {
    if (!d1) return null;
    let date = new Date(d1);
    date.setHours(0, 0, 0, 0);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getAllDropdown = async () => {
    try {
      let [
        vendor_api,
        partners_api,
        providers_api,
        booking_status_api,
        paymentstatus_api,
      ] = await Promise.all([
        apicall.get(`get_ezp_vendor_data`),
        apicall.get(`partners`),
        apicall.get(`providers`),
        apicall.get(`get_ezp_booking_status`),
        apicall.get(`get_ezp_payment_status`),
      ]);

      // console.log(
      //   "partners_api, providers_api, booking_status_api, paymentstatus_api---",
      //   partners_api,
      //   providers_api,
      //   booking_status_api,
      //   paymentstatus_api
      // );
      let pat = partners_api?.data?.map((ele) => {
        return {
          id: ele?.id,
          name: ele?.partner_name,
        };
      });
      setVendorData(vendor_api?.data);
      setAllPartner(pat);
      setAllProvider(providers_api?.data);
      setAllStatus(booking_status_api?.data);
      setAllPayment(paymentstatus_api?.data);
    } catch (e) {
      console.log("err---", e);
    }
  };

  const getBookingByDate = async () => {
    try {
      if (!startDate) return;
      setLoading(true);
      let currentId = ++lastRequestId.current;
      let startStr = formatDate(startDate);
      let endStr = formatDate(endDate);
      if (!endStr) endStr = startStr;
      // console.log("startstr---", startStr, "endStr------", endStr);

      let pat1 = selectedPartner?.map((ele) => ele?.id);
      let pro1 = selectedProvider?.map((ele) => ele?.id);
      let stat1 = selectedStatus?.map((ele) => ele?.id);
      let pay1 = selectedPayment?.map((ele) => ele?.id);

      let apiURL =
        startStr === endStr
          ? `get_ezp_booking?date=${startStr}`
          : `get_ezp_booking?startDate=${startStr}&&endDate=${endStr}`;
      // console.log("apiUerl--", apiURL);
      // apiURL += `&&partner=${pat1}&&provider=${pro1}&&status=${stat1}&&payment=${pay1}&limit=${limit}&page=${page}`;
      apiURL += `&&partner=${pat1}&&provider=${pro1}&&status=${stat1}&&payment=${pay1}&page=${page}`;

      const get_booking_data = await apicall.get(apiURL);

      if (currentId !== lastRequestId.current) return;

      // console.log("get_booking_data-----", get_booking_data);
      let allData = get_booking_data?.data;
      allData?.map((ele) => {
        ele.invoice = false;
        return ele;
      });

      setFullData(allData);
      console.log("allData-------", get_booking_data);

      // setTotalPages(get_booking_data?.pagination?.total_count || 0);

      const counts = {
        total: allData.length,
        progress: allData.filter(
          (item) => item.booking_status === "In Progress"
        ).length,
        completed: allData.filter((item) => item.booking_status === "Completed")
          .length,
        cancelled: allData.filter((item) => item.booking_status === "Cancelled")
          .length,
      };
      setOrderCounts(counts);
      setLoading(false);
    } catch (e) {
      console.log("err----", e);
    }
  };

  // console.log("fullData-------", fullData);

  const newBookingNavigate = (data) => {
    navigate(`/vendor_bookings/${data}`);
  };

  const onBackClick = (data) => {
    navigate(`/dashboard`);
  };

  const formatDateDisplay = (date) => {
    if (!date) return "";

    const d = new Date(date);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // return `${
    //   months[d.getUTCMonth()]
    // } ${d.getUTCDate()}, ${d.getUTCFullYear()}`;

    // let s1 = new Date(date);
    // s1.setHours(0, 0, 0, 0);

    // let d1 = date?.toLocaleDateString("en-GB")?.split(/[\/\-\.]/);
    // console.log("d1---", d1);
    // let d2 = `${d1[2]}-${d1[1]}-${d1[0]}`;
    // console.log("d2--", d2);

    // return d2;
    // return "";
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleDateChange = (data) => {
    try {
      // console.log("data-----", data);
      let [s, e] = data;

      let d1 = `${s.getFullYear()}-${String(s.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(s.getDate()).padStart(2, "0")}`;

      let d2 = e
        ? `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(
            2,
            "0"
          )}-${String(e.getDate()).padStart(2, "0")}`
        : null;

      console.log("d1-----", d1, d2);

      setDateRange(data);
    } catch (e) {
      console.log("error--", e);
    }
  };

  async function clearAll() {
    setSelectedPartner([]);
    setSelectedProvider([]);
    setSelectedStatus([]);
    setSelectedPayment([]);
  }

  const escapeCSVValue = (value) => {
    // Convert to string
    const stringValue = String(value);

    // If value contains comma, quote, or newline, wrap in quotes
    // and escape any existing quotes by doubling them
    if (
      stringValue.includes(",") ||
      stringValue.includes('"') ||
      stringValue.includes("\n")
    ) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }

    return stringValue;
  };

  const convertTo12Hour = (time24) => {
    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // Convert 0 to 12
    return `${hour}:${minute} ${ampm}`;
  };

  const exportToCSV = () => {
    // Convert data to CSV format
    const headers = exportheaders.join(",");
    // const rows = fullData.map((row) => Object.values(row).join(","));
    const rows = fullData.map((row, idx) => {
      let ans = [];

      for (let eachData of exportheaders) {
        if (eachData === "S.NO") {
          ans.push(idx + 1);
        } else {
          ans.push(escapeCSVValue(row[mappingColumns[eachData].name]));
        }
      }
      return ans.join(",");
    });
    // console.log("rows-----", fullData[0], headers, rows);

    const csv = [headers, ...rows].join("\n");

    // Create blob and download
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `bookings_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  function passFun() {}

  // const downloadInvoice = async () => {
  //   setLoading(true);

  //   try {
  //     const html2pdf = (await import("html2pdf.js")).default;

  //     const element = contentRef.current;
  //     const opt = {
  //       margin: [10, 10, 10, 10],
  //       filename: `invoice_${new Date().toISOString().split("T")[0]}.pdf`,
  //       image: { type: "jpeg", quality: 0.98 },
  //       html2canvas: {
  //         scale: 1.5,
  //         useCORS: true,
  //         letterRendering: true,
  //         allowTaint: false,
  //       },
  //       jsPDF: {
  //         unit: "mm",
  //         format: "a4",
  //         orientation: "portrait",
  //         compress: true,
  //       },
  //       pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  //     };

  //     await html2pdf().set(opt).from(element).save();
  //   } catch (error) {
  //     console.error("PDF generation failed:", error);
  //     alert("Failed to generate PDF");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const downloadInvoice = async () => {
    setLoading(true);

    try {
      console.log("downloadInv---", downloadInv);
      let htmlContent = `
      <!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Invoice Download</title>
    <style>
      body {
        font-family: "Poppins";
        background-color: #f9f9f9;
        margin: 0;
        padding: 0 2rem;
        font-size: 0.8rem;
      }
      .d-flex {
        display: flex;
      }
      .flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .justify-content-end {
        justify-content: flex-end;
      }
      
      .justify-between {
        display: flex;
        justify-content: space-between;
      }
      .invoice {
        margin-right: 2rem;
        font-size: 1rem;
        font-weight: 600;
      }
       .invoice_date {
        margin-right: 2rem;
        font-size: 0.8rem;
        font-weight: 400;
        margin-top:"8px"
      } 

      .text-center {
        text-align: center;
      }
      .fs2rem {
        font-size: 2rem;
      }
      .w15 {
        width: 15%;
      }
      .w-33 {
        width: 33%;
      }
      .w-50 {
        width: 50%;
      }
      .logoTitle {
        font-size: 1.5rem;
        font-weight: 600;
        color: #fff;
        background: #c9194a;
        padding: 1rem;
      }
      .gap-4 {
        gap: 8rem;
      }
      .text-gray-600 {
        color: #4a5568;
        font-size: 1.25rem;
      }
      .m-2 {
        margin: 1rem 0rem 0.2rem 0;
      }
      .mt-halfrem {
        margin-top: 0.5rem;
      }
      .bold {
        font-weight: 600;
      }
      .flex-start {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      table {
        width: 100%;
        margin-top: 1rem;
        border-collapse: collapse;
      }

      table tr {
        border-bottom: 1px solid #000;
      }

      table thead {
        background-color: #c9194a;
        color: #fff;
      }

      th,
      td {
        padding: 0.5rem;
        text-align: left;
        font-size: 0.8rem;
      }

      .fs_normal{
        font-size: 0.8rem;
      }

      .leftRounded {
        border-top-left-radius: 0.375rem;
        border-bottom-left-radius: 0.375rem;
        padding: 0.5rem;
        background: #c9194a;
        color: #fff;
      }
    </style>
  </head>
  <body>
    <div>
      <div class="flex-center">
        <h3 class="fs2rem">Tax Invoice</h3>
      </div>
      <div>
`;
      const safe = (val) => {
        if (val === null || val === undefined || val === "undefined") return "";
        return val;
      };
      const invoiceDate = new Date().toLocaleDateString("en-GB");
      if (vendorData?.[0]?.profile_image) {
        htmlContent += `
    <div class="d-flex justify-between" style="align-items: flex-start; margin-bottom: 10px;">
      <!-- LEFT: Logo + Company Info -->
      <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 4px;">
        <img
          src="${vendorData[0].profile_image}"
          alt="profile"
          style="height:50px; margin-bottom: 5px;"
        />
        <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 2px;">
          ${
            vendorData?.[0]?.first_name
              ? `<div>${vendorData[0].first_name}</div>`
              : ""
          }
          ${
            vendorData?.[0]?.email
              ? `<div class="text-gray-600 fs_normal">${vendorData[0].email}</div>`
              : ""
          }
          ${
            vendorData?.[0]?.phone_number
              ? `<div class="text-gray-600 fs_normal">${vendorData[0].phone_number}</div>`
              : ""
          }
          ${
            vendorData?.[0]?.city
              ? `<div class="text-gray-600 fs_normal">${vendorData[0].city}</div>`
              : ""
          }
          ${
            vendorData?.[0]?.state
              ? `<div class="text-gray-600 fs_normal">${vendorData[0].state}</div>`
              : ""
          }
          ${
            vendorData?.[0]?.country_name
              ? `<div class="text-gray-600 fs_normal">${vendorData[0].country_name}</div>`
              : ""
          }
        </div>
      </div>

      <!-- RIGHT: Invoice Info -->
      <div style="display: flex; flex-direction: column; align-items: flex-end;">
        <div class="invoice">INVOICE</div>
        <div class="invoice_date">${invoiceDate}</div>
      </div>
    </div>
  `;
      } else {
        htmlContent += `
    <div class="d-flex justify-between" style="align-items: flex-start; margin-bottom: 10px;">
      <!-- LEFT: Company Details -->
      <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 2px;">
        ${
          vendorData?.[0]?.first_name
            ? `<div class="logoTitle">${vendorData[0].first_name}</div>`
            : ""
        }
        ${
          vendorData?.[0]?.city
            ? `<div class="text-gray-600 fs_normal">${vendorData[0].city}</div>`
            : ""
        }
        ${
          vendorData?.[0]?.state
            ? `<div class="text-gray-600 fs_normal">${vendorData[0].state}</div>`
            : ""
        }
        ${
          vendorData?.[0]?.country_name
            ? `<div class="text-gray-600 fs_normal">${vendorData[0].country_name}</div>`
            : ""
        }
        ${
          vendorData?.[0]?.email
            ? `<div class="text-gray-600 fs_normal">${vendorData[0].email}</div>`
            : ""
        }
        ${
          vendorData?.[0]?.phone_number
            ? `<div class="text-gray-600 fs_normal">${vendorData[0].phone_number}</div>`
            : ""
        }
      </div>

      <!-- RIGHT: Invoice Info -->
      <div style="display: flex; flex-direction: column; align-items: flex-end;">
        <div class="invoice">INVOICE</div>
        <div class="invoice_date">${invoiceDate}</div>
      </div>
    </div>
  `;
      }

      // Contact info section: mobile/email one by one
      // htmlContent += `
      // <div style="margin-bottom: 20px;">
      //   ${vendorData?.[0]?.email ? `<div class="text-gray-600 fs_normal">${vendorData[0].email}</div>` : ""}
      //   ${vendorData?.[0]?.phone_number ? `<div class="text-gray-600 fs_normal">${vendorData[0].phone_number}</div>` : ""}
      // </div>
      // `;

      //     htmlContent += `
      // <header class="d-flex m-2 gap-4">
      //   <div>
      //     ${vendorData?.[0]?.first_name ? `<div class="text-gray-600 bold fs_normal">${safe(vendorData[0].first_name)}</div>` : ""}
      //     ${vendorData?.[0]?.city ? `<div class="text-gray-600 fs_normal">${safe(vendorData[0].city)}</div>` : ""}
      //     ${vendorData?.[0]?.state ? `<div class="text-gray-600 fs_normal">${safe(vendorData[0].state)}</div>` : ""}
      //     ${vendorData?.[0]?.country_name ? `<div class="text-gray-600 fs_normal">${safe(vendorData[0].country_name)}</div>` : ""}
      //   </div>

      //   <div>
      //     ${vendorData?.[0]?.email ? `<div class="text-gray-600 fs_normal">${safe(vendorData[0].email)}</div>` : ""}
      //     ${vendorData?.[0]?.phone_number ? `<div class="text-gray-600 fs_normal">${safe(vendorData[0].phone_number)}</div>` : ""}
      //   </div>
      // </header>`;

      let bill_to = downloadInv[0]?.partner_name;
      if (downloadInv[0]?.partner_name === "Self") {
        bill_to = downloadInv[0]?.user_name;
      }

      htmlContent += ` 
      <div>
        <h3>
          Bill to : <span>${bill_to ? bill_to : "N/A"}</span>
        </h3>
         <h3>
       <div style="display: flex; flex-direction: column; align-items: flex-start;">
        ${
          downloadInv[0]?.house_no
            ? `<div class="text-gray-600 fs_normal">${downloadInv[0].house_no}</div>`
            : ""
        }
        ${
          downloadInv[0]?.area
            ? `<div class="text-gray-600 fs_normal">${downloadInv[0].area}</div>`
            : ""
        }
        ${
          downloadInv[0]?.location
            ? `<div class="text-gray-600 fs_normal">${downloadInv[0].location}</div>`
            : ""
        }
        ${
          downloadInv[0]?.state
            ? `<div class="text-gray-600 fs_normal">${downloadInv[0].state}</div>`
            : ""
        }
    </div>
  </h3>
        <div style="margin-top: 5px; font-size: 15px; color: black; text-align: right;">
  * All values in ${currency}
</div>
      </div>`;

      htmlContent += `  <section>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Booking ID</th>
              <th>Items & Description </th>
              <th>Rate</th>
              <th>Discount</th>
              <th>Tax</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
           
       `;

      let rows = [];
      let booking_ids = [];

      // downloadInv?.map((ele, idx1) => {
      //   booking_ids.push(ele?.booking_id);
      //   rows.push(`
      //      <tr>
      //         <td>${idx1 + 1}</td>
      //         <td>${ele["display_booking_id"]}</td>
      //         <td>${ele["service_name"]}
      //               ${
      //                 ele["service_type_name"]
      //                   ? ` - ${ele["service_type_name"]}`
      //                   : ""
      //               }
      //                -
      //               ${ele["service_offering_name"]} @
      //               ${formatDateDisplay(ele["service_date"])}
      //                -
      //               ${convertTo12Hour(ele["service_time"])}</td>
      //         <td>${currency} ${ele["discount"]}</td>
      //         <td>${currency} ${ele["tax"]}</td>
      //         <td>${currency} ${ele["total"]}</td>
      //       </tr>
      //     `);
      // });
      downloadInv?.map((ele, idx1) => {
        booking_ids.push(ele?.booking_id);

        rows.push(`
    <tr>
      <td>${idx1 + 1}</td>
      <td>${safe(ele["display_booking_id"])}</td>
      <td>
        ${safe(ele["service_name"])}
        ${
          ele["service_type_name"] ? ` - ${safe(ele["service_type_name"])}` : ""
        }
        ${
          ele["service_offering_name"]
            ? ` - ${safe(ele["service_offering_name"])}`
            : ""
        }
        ${
          ele["service_date"]
            ? ` @ ${formatDateDisplay(ele["service_date"])}`
            : ""
        }
        ${
          ele["service_time"]
            ? ` - ${convertTo12Hour(ele["service_time"])}`
            : ""
        }
      </td>
      <td>${safe(ele["price"] || 0)}</td>
      <td>${safe(ele["discount"] || 0)}</td>
      <td>${safe(ele["tax"] || 0)}</td>
      <td>${safe(ele["total"] || 0)}</td>
    </tr>
  `);
      });
      rows.push(`   </tbody>
        </table>
      </section>`);

      let ans = rows.join("");
      htmlContent += ans;

      let itemRows = [];
      let itemIndex = 1;

      downloadInv?.forEach((ele) => {
        const itemNames = (ele?.item_names || "").split(",");
        const itemPrices = (ele?.item_prices || "").split(",");

        itemNames.forEach((name, index) => {
          if (name.trim()) {
            itemRows.push(`
        <tr>
          <td>${itemIndex++}</td>
          <td>${safe(ele["display_booking_id"])}</td>
          <td>${name.trim()}</td>
          <td>${currency} ${itemPrices[index] || 0}</td>
        </tr>
      `);
          }
        });
      });

htmlContent += `
<section style="margin-top: 4rem;">

  <div style="display:flex; width:100%; gap:20px; align-items:flex-start;">

    <!-- LEFT SIDE -->
    ${
      itemRows.length > 0
        ? `
      <div style="width:70%;">

        <div style="font-weight:600; margin-bottom:10px; font-size:16px;">
          Added Items
        </div>

        <table style="width:100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th>#</th>
              <th>Booking ID</th>
              <th>Item</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            ${itemRows.join("")}
          </tbody>
        </table>

      </div>
    `
        : ``
    }

    <!-- RIGHT SIDE (ALWAYS SHOW) -->
    <div style="width:30%; margin-left:auto;">

      <div class="d-flex mt-halfrem">
        <div class="w-50 bold">Discount</div>
        <div class="w-50 bold">${currency} ${safe(getAmount("discount") || 0)}</div>
      </div>

      <div class="d-flex mt-halfrem">
        <div class="w-50 bold">Tax</div>
        <div class="w-50 bold">${currency} ${safe(getAmount("tax") || 0)}</div>
      </div>

      <div class="d-flex mt-halfrem leftRounded">
        <div class="w-50 bold">Total</div>
        <div class="w-50 bold">${currency} ${safe(getAmount("total") || 0)}</div>
      </div>

      <div class="d-flex mt-halfrem">
        <div class="w-50 bold">Total Paid Amount</div>
        <div class="w-50 bold">${currency} ${safe(getAmount("total_paid_amount") || 0)}</div>
      </div>

      <div class="d-flex mt-halfrem leftRounded">
        <div class="w-50 bold">Balance Due</div>
        <div class="w-50 bold">${currency} ${safe(getAmount("balance_due") || 0)}</div>
      </div>

    </div>

  </div>

</section>
`;

      //       htmlContent += `
      // <section style="margin-top: 4rem" class="d-flex justify-content-end">
      //   <div class="w-33">
      //     <div class="d-flex mt-halfrem">
      //       <div class="w-50 bold">Discount</div>
      //       <div class="w-50 bold">${safe(getAmount("discount") || 0)}</div>
      //     </div>
      //     <div class="d-flex mt-halfrem">
      //       <div class="w-50 bold">Tax</div>
      //       <div class="w-50 bold">${safe(getAmount("tax") || 0)}</div>
      //     </div>
      //     <div class="d-flex mt-halfrem leftRounded">
      //       <div class="w-50 bold">Total</div>
      //       <div class="w-50 bold">${safe(getAmount("total") || 0)}</div>
      //     </div>
      //   </div>
      // </section>`;

      htmlContent += `  <div style="margin-top: 4rem"></div>

      <div class="footer-note text-center text-gray-400 text-sm border-t pt-4">
        <p class="font-semibold mb-1">Thank you for your business.</p>
        <p>
          This is a system generated invoice, no signature required for the
          same.
        </p>
      </div>
    </div>
  </body>
</html>`;

      console.log("htmlContent-----", htmlContent);

      let data = {
        booking_ids: booking_ids,
        htmlContent: htmlContent,
      };
      const response = await apicall.generate_pdf(data, "generate_pdf");
      setDownloadInv([]);
      await getBookingByDate();
      setLoading(false);
      console.log("response--generate_pdf----", response);
    } catch (error) {
      console.error("PDF generation failed:", error);
      alert("Failed to generate PDF");
    } finally {
      setLoading(false);
    }
  };

  console.log("vendorData---", vendorData);

  function close() {
    console.log("close.......");
    setOpen(false);
  }

  function checkBoxInvoice(data) {
    try {
      let copyFullData = JSON.parse(JSON.stringify(fullData));
      console.log(copyFullData, "copyFullData");
      let partner_name = downloadInv?.[0]?.partner_name;

      if (downloadInv?.length === 0) {
        if (data?.partner_name === "Self") {
          partner_name = "Self" + data?.phone_number;
        } else {
          partner_name = data?.partner_name;
        }
      } else if (downloadInv?.[0]?.partner_name?.includes("Self")) {
        partner_name = "Self" + downloadInv?.[0]?.phone_number;
      } else {
        partner_name = downloadInv?.[0]?.partner_name;
      }

      if (partner_name === "Self" + data?.phone_number) {
        for (let i of copyFullData) {
          if (
            i.group_id === data?.group_id &&
            partner_name === "Self" + data?.phone_number &&
            data?.partner_name === "Self"
          ) {
            i.invoice = !i.invoice;
            break;
          }
        }
      } else if (
        data?.partner_name !== "Self" &&
        data?.partner_name === partner_name
      ) {
        for (let i of copyFullData) {
          if (
            i.group_id === data?.group_id &&
            i.partner_name === data?.partner_name &&
            data?.partner_name !== "Self" &&
            data?.partner_name === partner_name
          ) {
            i.invoice = !i.invoice;
            break;
          }
        }
      }

      let invoiceArr = copyFullData.filter((ele) => ele.invoice);

      setDownloadInv(invoiceArr);

      setFullData(copyFullData);
    } catch (e) {
      console.log("error---", e);
    }
  }

  const getPageNumbers = () => {
    const pageNumbers = [];
    const totalPagesToShow = 5;
    const halfWay = Math.floor(totalPagesToShow / 2);

    if (totalPages <= totalPagesToShow) {
      // If total pages are less than or equal to totalPagesToShow, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always show first page
      pageNumbers.push(1);

      let startPage = Math.max(2, page - halfWay);
      let endPage = Math.min(totalPages - 1, page + halfWay);

      // Adjust start and end if we're near the beginning or end
      if (page <= halfWay + 1) {
        endPage = totalPagesToShow - 1;
      } else if (page >= totalPages - halfWay) {
        startPage = totalPages - totalPagesToShow + 2;
      }

      // Add ellipsis after first page if needed
      if (startPage > 2) {
        pageNumbers.push("...");
      }

      // Add middle pages
      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      // Add ellipsis before last page if needed
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }

      // Always show last page
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  const getAmount = (label) => {
    let s = 0;

    let copydownloadInv = JSON.parse(JSON.stringify(downloadInv));
    copydownloadInv?.map((ele) => {
      s = parseFloat(parseFloat(s) + parseFloat(ele[label]));
    });

    return s;
  };

  const downloadPDF = async () => {
    const htmlContent = `
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            h1 { color: #333; }
          </style>
        </head>
        <body>
          <h1>My Report</h1>
          <p>This is HTML content rendered as PDF.</p>
        </body>
      </html>
    `;

    const response = await apicall.generate_pdf(htmlContent, "generate_pdf");

    console.log("response---", response);
    // const blob = await response.blob();
    // const url = URL.createObjectURL(blob);

    // // Trigger download
    // const a = document.createElement("a");
    // a.href = url;
    // a.download = "document.pdf";
    // a.click();
    // URL.revokeObjectURL(url);
  };

  // console.log("downloadInv---", downloadInv);

  return (
    <>
      <RotateDevicePopup />
      <div onClick={close}>
        <div style={{ display: "none" }}>
          <div
            ref={contentRef}
            style={{
              padding: "4px",
              paddingTop: "1rem",
              margin: "0 auto",
              boxSizing: "border-box",
            }}
            className="bg-white rounded-lg shadow-lg p-8"
          >
            <div className="d-flex justify-content-center">
              <h3 className=" p-2 py-1 font-bold text-center mb-8 text-gray-800">
                Tax Invoice
              </h3>
            </div>
            <header className="d-flex align-items-start gap-4 mb-8">
              {vendorData?.[0]?.profile_image ? (
                <div>
                  <img
                    src={vendorData?.[0]?.profile_image}
                    // crossOrigin="anonymous"
                    alt="profile"
                  />
                </div>
              ) : (
                <div
                  style={{ color: "#fff", backgroundColor: "rgb(223, 48, 94)" }}
                  className="text font-bold p-4 text-blue-600"
                >
                  {vendorData?.[0]?.first_name}
                </div>
              )}

              <div>
                <h5 className="text-gray-600">{vendorData?.[0]?.first_name}</h5>
                <div className="text-gray-600">{vendorData?.[0]?.city}</div>
                <div className="text-gray-600">{vendorData?.[0]?.state}</div>
                <div className="text-gray-600">
                  {vendorData?.[0]?.country_name}
                </div>
              </div>
              <div>
                <div className="text-gray-600">{vendorData?.[0]?.email}</div>
                <div className="text-gray-600">
                  {vendorData?.[0]?.phone_number}
                </div>
              </div>
            </header>

            <div className="d-flex mt-4">
              <div style={{ width: "10%" }} className="invoiceHead">
                Booking ID
              </div>
              <div style={{ width: "60%" }} className="invoiceHead">
                Product/Services
              </div>
              <div style={{ width: "30%" }} className="invoiceHead">
                Amount
              </div>
            </div>

            {downloadInv?.map((ele, idx1) => {
              return (
                <>
                  <div className="d-flex">
                    <div style={{ width: "10%" }} className="invoiceBody">
                      {ele["display_booking_id"]}
                    </div>
                    <div
                      style={{ width: "60%", paddingRight: "6rem" }}
                      className="invoiceBody"
                    >
                      {ele["service_name"]}
                      {ele["service_type_name"]
                        ? ` - ${ele["service_type_name"]}`
                        : ""}
                      {" - "}
                      {ele["service_offering_name"]} @{" "}
                      {formatDateDisplay(ele["service_date"])}
                      {" - "}
                      {convertTo12Hour(ele["service_time"])}
                    </div>
                    <div style={{ width: "30%" }} className="invoiceBody">
                      {ele["discount"] ? (
                        <div className="d-flex justify-content-between">
                          <div> Discount:</div>{" "}
                          <div>
                            {" "}
                            {currency} {ele["discount"]}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className="d-flex justify-content-between">
                        <div> Tax:</div>{" "}
                        <div>
                          {" "}
                          {currency} {ele["tax"]}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div> Amount:</div>{" "}
                        <div>
                          {" "}
                          ${currency} {ele["total"]}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </>
              );
            })}

            <div style={{ marginTop: "6rem" }}> </div>
            <footer className="d-flex justify-content-end ">
              <div style={{ width: "30%" }} className="invoiceBody">
                <div className="d-flex justify-content-between">
                  <div> Discount:</div>{" "}
                  <div>
                    {" "}
                    ${currency} {getAmount("discount")}
                  </div>
                </div>

                <div className="d-flex justify-content-between">
                  <div> Tax:</div>{" "}
                  <div>
                    {" "}
                    {currency} {getAmount("tax")}
                  </div>
                </div>
                <div className="d-flex justify-content-between btn-danger p-2 leftRounded">
                  <div> Total Due:</div>{" "}
                  <div>
                    {" "}
                    {currency} {getAmount("total")}
                  </div>
                </div>
              </div>
            </footer>
            <div className="footer-note text-center text-gray-400 text-sm border-t pt-4">
              <p className="font-semibold mb-1">Thank you for your business.</p>
              <p>
                This is a system generated invoice, no signature required for
                the same.
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <button
            className="btn btn-link text-dark p-0"
            onClick={onBackClick}
            style={{ fontSize: "14px", textDecoration: "none" }}
          >
            <MdArrowBack size={20} /> BACK
          </button>

          {/* <button onClick={downloadPDF}>Download PDF</button> */}

          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              <div
                onClick={() => navigate("/vendor_bookings")}
                className="btn-danger rounded p-2 px-3 cursor-pointer "
              >
                New Booking
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center flex-wrap gap-2 mb-3  mobile-filters">
          <Form.Group>
            <div onClick={(e) => e.stopPropagation()}>
              <div className="position-relative w-100">
                <div className="d-flex flex-column">
                  <div>
                    <Form.Label>Select Date</Form.Label>
                  </div>
                  <button
                    className="btn d-flex align-items-center gap-2 px-3"
                    style={{
                      height: "40px",
                      fontSize: "14px",
                      borderRadius: "6px",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #E3EBF8",
                      color: "#000000",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpen(!open);
                    }}
                  >
                    {startDate
                      ? endDate &&
                        new Date(startDate).getTime() !==
                          new Date(endDate).getTime()
                        ? `${formatDateDisplay(
                            startDate
                          )} - ${formatDateDisplay(endDate)}`
                        : formatDateDisplay(startDate)
                      : "Date"}{" "}
                    {/* {startDate
                  ? endDate && startDate !== endDate
                    ? JSON.stringify(startDate) - JSON.stringify(endDate)
                    : JSON.stringify(startDate)
                  : "Date"}{" "} */}
                    <FaRegCalendarAlt />
                  </button>
                </div>

                {open && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: "0",
                      zIndex: 9999,
                      backgroundColor: "#fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      borderRadius: "8px",
                    }}
                  >
                    <DatePicker
                      selectsRange
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => handleDateChange(update)}
                      inline
                    />
                  </div>
                )}
              </div>
            </div>
          </Form.Group>
          <Form.Group>
            <div>
              <div>
                <Form.Label>Profile</Form.Label>
              </div>
              <MultiSelect
                value={selectedPartner}
                onChange={(e) => setSelectedPartner(e.value)}
                options={allPartner}
                optionLabel="name"
                filter
                filterDelay={400}
                placeholder="Select Profile"
                maxSelectedLabels={3}
                // className="form-control "
                style={{ width: "100%", height: "40px" }}
              />
            </div>
          </Form.Group>
          <Form.Group>
            <div>
              <div>
                <Form.Label>Crew</Form.Label>
              </div>
              <MultiSelect
                value={selectedProvider}
                onChange={(e) => setSelectedProvider(e.value)}
                options={allProvider}
                optionLabel="name"
                filter
                filterDelay={400}
                placeholder="Select Crew"
                maxSelectedLabels={3}
                // className="form-control "
                style={{ width: "100%", height: "40px" }}
              />
            </div>
          </Form.Group>
          <Form.Group>
            <div>
              <div>
                <Form.Label>Booking Status</Form.Label>
              </div>
              <MultiSelect
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.value)}
                options={allStatus}
                optionLabel="name"
                filter
                filterDelay={400}
                placeholder="Select Booking Status"
                maxSelectedLabels={3}
                // className="form-control "
                style={{ width: "100%", height: "40px" }}
              />
            </div>
          </Form.Group>
          <Form.Group>
            <div>
              <div>
                <Form.Label>Payment Status</Form.Label>
              </div>
              <MultiSelect
                value={selectedPayment}
                onChange={(e) => setSelectedPayment(e.value)}
                options={allPayment}
                optionLabel="name"
                filter
                filterDelay={400}
                placeholder="Select Payment Status"
                maxSelectedLabels={3}
                // className="form-control "
                style={{ width: "100%", height: "40px" }}
              />
            </div>
          </Form.Group>
          <div
            className="cursor-pointer mt-4 danger-underline"
            onClick={() => clearAll()}
          >
            Clear All
          </div>
        </div>
        <div className="d-flex gap-2  mb-2 mobile-actions">
          <button
            className="btn px-3"
            style={{
              height: "40px",
              fontSize: "14px",
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
              border: "1px solid #E3EBF8",
              color: "#000000",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            onClick={() => exportToCSV()}
          >
            <img
              src={ExcelIcon}
              alt="Excel"
              style={{ width: "20px", height: "20px" }}
            />
            Export
          </button>

          <button
            onClick={downloadInv?.length !== 0 ? downloadInvoice : passFun}
            style={{
              border: "none",
              opacity: downloadInv?.length === 0 ? 0.5 : 1,
            }}
            className={` btn-danger rounded border-color-none`}
            disabled={downloadInv?.length === 0 ? true : false}
          >
            {loading ? <>Generating ...</> : <>Download Invoice</>}
          </button>
        </div>
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 mb-4">
          {[
            {
              label: <strong>Total</strong>,
              value: orderCounts?.total,
              icon: <LuClock style={{ fontSize: "20px", color: "#037FE8" }} />,
              bgColor: "#F2F9FF",
              tab: "table",
              status: "All",
              color: "#037FE8",
            },
            {
              label: <strong>Completed</strong>,
              value: orderCounts?.completed,
              icon: (
                <LuClipboardCheck
                  style={{ fontSize: "20px", color: "#CCCC00" }}
                />
              ),
              bgColor: "#FFFFCC7F",
              tab: "table",
              status: "Completed",
              color: "#CCCC00",
            },
            {
              label: <strong>In Progress</strong>,
              value: orderCounts?.progress,
              icon: (
                <HiOutlineUsers
                  style={{ fontSize: "20px", color: "#92007E" }}
                />
              ),
              bgColor: "#FFF0FD",

              tab: "table",
              status: "In Progress",
              color: "#92007E",
            },
            {
              label: <strong>Cancelled</strong>,
              value: orderCounts?.cancelled,
              icon: (
                <HiOutlineUsers
                  style={{ fontSize: "20px", color: "#FF0000" }}
                />
              ),
              bgColor: "#FDEDED",
              tab: "table",
              status: "Cancelled",
              color: "#FF0000",
            },
          ].map((item, index) => (
            <div className="col" key={index}>
              <div
                className="card d-flex flex-row align-items-center p-3"
                style={{
                  cursor: "pointer",
                  borderRadius: "12px",
                  height: "90px",
                  border: "1px solid #E3EBF8",
                }}
              >
                <div
                  style={{
                    backgroundColor: item.bgColor,
                    borderRadius: "50%",
                    width: "48px",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "16px",
                  }}
                >
                  {item.icon}
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: `${item.color}`,
                      marginBottom: "4px",
                    }}
                  >
                    {item.label}
                  </div>
                  <h5
                    style={{
                      color: `${item.color}`,
                      fontSize: "18px",
                      fontWeight: "700",
                      margin: 0,
                    }}
                  >
                    {item.value}
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white mt-3 rounded-2">
          <div className="table-responsive">
            <Table
              bordered
              hover
              className="align-middle mb-0 bg-custom-light border-custom custom-table dashboardTable "
              style={{ fontSize: "14px" }}
            >
              <thead>
                <tr className="table-header-row">
                  {headers &&
                    headers?.map((header, idx) => (
                      <th
                        style={{
                          minWidth: mappingColumns?.[header]?.width || "auto",
                        }}
                        key={idx}
                      >
                        {header}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  Array(10)
                    .fill(null)
                    .map((_, index) => (
                      <tr key={index}>
                        <td>
                          <Skeleton width="30px" />
                        </td>
                        <td>
                          <Skeleton width="30px" />
                        </td>
                        <td>
                          <Skeleton width="150px" />
                        </td>
                        <td>
                          <Skeleton width="120px" />
                        </td>
                        <td>
                          <Skeleton width="80px" />
                        </td>
                        <td>
                          <Skeleton width="100px" />
                        </td>
                        <td>
                          <Skeleton width="80px" />
                        </td>
                        <td>
                          <Skeleton width="80px" />
                        </td>{" "}
                        <td>
                          <Skeleton width="80px" />
                        </td>{" "}
                        <td>
                          <Skeleton width="80px" />
                        </td>{" "}
                        <td>
                          <Skeleton width="80px" />
                        </td>
                        <td>
                          <div className="d-flex gap-3">
                            <Skeleton width="80px" />
                            <Skeleton width="80px" />
                          </div>
                        </td>
                      </tr>
                    ))
                ) : (
                  <Fragment>
                    {fullData?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1} </td>

                          {headers &&
                            headers?.map((col, idx) => {
                              return (
                                <>
                                  {![0].includes(idx) && (
                                    <>
                                      {mappingColumns?.[col]?.name ===
                                      "display_booking_id" ? (
                                        <td
                                          className="linkText cursor-pointer"
                                          onClick={() =>
                                            newBookingNavigate(
                                              data[mappingColumns?.[col]?.name]
                                            )
                                          }
                                          key={idx}
                                        >
                                          {data[mappingColumns?.[col]?.name]}
                                        </td>
                                      ) : (
                                        <>
                                          {mappingColumns?.[col]?.name ===
                                          "invoice_id" ? (
                                            <>
                                              {data[
                                                mappingColumns?.[col]?.name
                                              ] ? (
                                                <td>
                                                  <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={
                                                      data[
                                                        mappingColumns?.[col]
                                                          ?.name
                                                      ]
                                                    }
                                                  >
                                                    Download
                                                  </a>
                                                </td>
                                              ) : (
                                                <td>
                                                  <input
                                                    checked={data["invoice"]}
                                                    onClick={() =>
                                                      checkBoxInvoice(data)
                                                    }
                                                    type="checkbox"
                                                  />
                                                </td>
                                              )}
                                            </>
                                          ) : (
                                            <td key={idx}>
                                              {
                                                data[
                                                  mappingColumns?.[col]?.name
                                                ]
                                              }
                                            </td>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              );
                            })}
                        </tr>
                      );
                    })}
                  </Fragment>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Pagination */}
        {/* <div className="d-flex justify-content-end align-items-center mt-4">
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn bg-white text-black btn-outline-borders d-flex align-items-center px-2"
            style={{ height: "32px", fontSize: "14px", minWidth: "32px" }}
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            disabled={page === 1}
          >
            <FaArrowLeft /> Prev
          </button>

          <div className="d-flex">
            {getPageNumbers().map((num, index) => (
              <button
                key={index}
                className={`btn ${
                  num === "..."
                    ? "btn-outline-borders bg-white text-black"
                    : page === num
                    ? "bg-black text-white"
                    : "btn-outline-borders bg-white text-black"
                }`}
                style={{
                  height: "32px",
                  fontSize: "14px",
                  marginRight:
                    index !== getPageNumbers().length - 1 ? "6px" : "0",
                  borderRadius: "4px",
                  padding: "0 12px",
                  fontWeight: page === num ? 600 : 400,
                  border:
                    page === num ? "1px solid black" : "1px solid #E3EBF8",
                  minWidth: "32px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: num === "..." ? "default" : "pointer",
                  pointerEvents: num === "..." ? "none" : "auto",
                }}
                onClick={() => num !== "..." && setPage(num)}
                disabled={num === "..."}
              >
                {num}
              </button>
            ))}
          </div>

          <button
            className="btn bg-white text-black btn-outline-borders d-flex align-items-center px-2"
            style={{ height: "32px", fontSize: "14px", minWidth: "32px" }}
            onClick={() => setPage((prev) => prev + 1)}
            disabled={page === totalPages}
          >
            <FaArrowRight /> Next
          </button>

          <select
            className="form-select ms-2 bg-white text-black btn-outline-borders"
            style={{
              width: "140px",
              height: "34px",
              fontSize: "14px",
              borderRadius: "6px",
            }}
            value={limit}
            onChange={(e) => {
              setPage(1);
              setLimit(Number(e.target.value));
            }}
          >
            <option value={10}>10 per page</option>
            <option value={20}>20 per page</option>
            <option value={50}>50 per page</option>
          </select>
        </div>
      </div> */}
      </div>
    </>
  );
}

export default DashboardDetailed;
